// Route shell for the ERA line matcher.
//
// Two ways in, both landing here:
//   /billing/era-match/:accountId
//     from the account's Statement Actions menu, with nothing pre-selected.
//   /billing/era-match/:accountId?eraLogId=&schemeClaimId=&eraLineKey=
//     from an unmatched claim in the ERA detail view, pre-armed on that line.
//
// The role gate is server-side on every endpoint the screen calls; this only
// decides whether to render the screen or an explanation, so a user without
// Finance or SuperAdmin gets a sentence rather than a wall of failed requests.

import React, { useMemo } from "react";
import { Alert, Container } from "react-bootstrap";
import { useParams, useSearchParams } from "react-router-dom";

import EraMatch from "../Components/ERA/EraMatch";
import "./home.css";

const ALLOWED_ROLES = ["Finance", "SuperAdmin"];

function currentUserRoles() {
  try {
    const raw = sessionStorage.getItem("userInfo") || sessionStorage.getItem("user");
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return [
      ...(Array.isArray(parsed?.role) ? parsed.role : parsed?.role ? [parsed.role] : []),
      ...(Array.isArray(parsed?.roles) ? parsed.roles : []),
      ...(Array.isArray(parsed?.permissions) ? parsed.permissions : []),
    ].map(String);
  } catch {
    // The session value is a bare JWT on some paths, which is not JSON. The
    // server gate is authoritative either way, so fall through to rendering and
    // let the API answer.
    return null;
  }
}

export default function EraMatchPage() {
  const { accountId } = useParams();
  const [searchParams] = useSearchParams();

  const preArm = useMemo(() => {
    const eraLogId = searchParams.get("eraLogId");
    const schemeClaimId = searchParams.get("schemeClaimId");
    const eraLineKey = searchParams.get("eraLineKey");
    return eraLogId && schemeClaimId && eraLineKey
      ? { eraLogId, schemeClaimId, eraLineKey }
      : null;
  }, [searchParams]);

  const roles = currentUserRoles();
  const blocked = roles !== null && !roles.some((r) => ALLOWED_ROLES.includes(r));

  // BootNav is fixed-top, so every page under Layout offsets its content or the
  // first thing it renders sits underneath the navbar. Applied here, around both
  // branches, so EraMatch's own loading / error / content returns all inherit it
  // rather than each needing to remember.
  return (
    <div style={{ marginTop: "50px" }}>
      {blocked ? (
        <Container fluid className="pt-2 acc-list">
          <Alert variant="info" className="mb-0">
            Matching remittance to invoices needs the Finance or SuperAdmin role.
          </Alert>
        </Container>
      ) : (
        <EraMatch accountId={accountId} preArm={preArm} />
      )}
    </div>
  );
}
